<script setup lang="ts">

import type { IMarketplaceViewModel } from "@app/MyMarketplace/Types/IMarketplaceViewModel";
import Carousel from "../Common/Carousel.vue";
import { useRouter } from "@library/Services";
import type { IOfferTile } from "@domain/Marketplace";

type Props = { 
    title?: string, 
    subTitle?: string 
};
const model = defineModel<IMarketplaceViewModel>( { required: true } );
const { title, subTitle } = defineProps<Props>();

/**
 * Navigate to the offer page
 * @param itemId 
 */
function onItemClick( offer: IOfferTile ) 
{
    const router = useRouter();
    router.go( `/my-marketplace/offer/${ offer.offerId }` );
}

</script>

<template>

    <div class="px-4 3xl:px-6 flex flex-col gap-2 3xl:gap-3 mt-2
                bg-gradient-to-b from-gray-900 via-70% via-gray-800 to-gray-900">
        <h1 class="tracking-wider text-base 3xl:text-xl">
            {{ title }}
        </h1>

        <h2 class="-mt-2 tracking-wider text-sm 3xl:text-lg opacity-40">
            {{ subTitle }}
        </h2>

        <Carousel :offers="model.specialFeatureOffers.offers"
            @on-select="( offer: IOfferTile ) => onItemClick( offer )" />
    </div>
    
</template>